import React from 'react'
import styled from 'styled-components'
import { withSiteData } from 'react-static'

const Container = styled.div`
  min-height: 100vh;
  padding: 4rem;
  max-width: 90%;
  margin: 0 auto;
  position: relative;
`

const Title = styled.h1`
  font-size: 30px;
`

const SubTitle = styled.h2`
  font-size: 15px;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
`

const Methods = styled.div`
  margin: 2rem 0;
`

const Domains = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const Domain = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 200px;
  height: 200px;

  margin: 0.5rem;
  padding: 1rem;
  background: #eeeeee;
  border-radius: 3px;

  h3 {
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;

    margin-bottom: 0.5rem;
  }
`

const Contact = styled.a`
  background-color: grey;
  color: white;
  font-size: 13px;
  padding: 2px 5px;
  border-radius: 3px;

  position: absolute;
  top: 2rem;
  right: 2rem;
`

const domains = [
  { name: 'blockout.io', desc: 'privacy' },
  { name: 'psiblock.io', desc: 'Ψ' },
  { name: 'sigmablock.io', desc: 'Σ' },
  { name: 'gigablock.io', desc: '' },
  { name: 'unmount.io', desc: '' },
  { name: 'blockmaking.io', desc: '' },
  { name: 'pillars.io', desc: '' },
  { name: 'backblock.io', desc: '' },
  { name: 'kiloblock.io', desc: '' },
]

export default withSiteData(() => (
  <Container>
    <Title>Crypto-related domains</Title>
    <SubTitle>FOR SALE</SubTitle>

    <Methods>
      Using <span style={{ color: '#EE9232' }}>Bitcoin</span>,{' '}
      <span style={{ color: '#4B89E2' }}>Ethereum</span> or{' '}
      <span
        style={{
          color: '#5EBA5E',
        }}
      >
        Escrow.com
      </span>
      {'. '}
      <Contact href="mailto:domainscrypto@protonmail.com">CONTACT US</Contact>
    </Methods>

    <Domains>
      {domains.map(domain => (
        <Domain key={domain.name}>
          <h3>{domain.name}</h3>
          <span>{domain.desc || '-'}</span>
        </Domain>
      ))}
    </Domains>
  </Container>
))



// WEBPACK FOOTER //
// /Users/apercu/git/ashlar/statics/domains/src/components/Home.js